import { Box, Button, Chip, LinearProgress, Modal, Paper, Typography, useMediaQuery } from "@mui/material";
import { styled } from "@mui/material/styles";
import emptyFolder from "@/assets/empty_folder.png";
import MyToastShow from "@/components/Layout/MyToast";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
import { useBorrarFacturaMutation, useSubirFacturaACarpetaMutation } from "@/redux/api/archivoApi";
import { developerLog } from "@/utils/devLogs";
import { ICarrito } from "../../../redux/models/typesInformes";
import { useAppSelector } from "../../../redux/store";
import EnvioProgramado from "../EnvioProgramado";
import "./styles.css";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.js`;

const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
});

type ModalCarpetaProps = {
    open: boolean;
    onCancel: () => void;
    carpeta?: ICarrito;
    onSubmit: (updated: ICarrito) => void
};

const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 900,
    boxShadow: 24,
    p: 4,
};

export type LiquidarInformesArgs = {
    listaDevuelta: number[];
    bool: boolean;
};

const RenderPreviewFactura = ({ file, link }: { file?: File | null, link?: string }) => {
    const [numPages, setNumPages] = useState<number>();
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [hover, setHover] = useState<boolean>(false);
    useEffect(() => {

        return () => {
            if (file) {
                URL.revokeObjectURL(urlObject || '');
            }
        }


    }, [file, link])


    if (!file && !link) {
        return <img
            src={emptyFolder}
        />;
    }
    const type = file?.type || link?.endsWith('.pdf') ? 'application/pdf' : 'image/*';
    const urlObject = file ? URL.createObjectURL(file) : link;



    const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
        setNumPages(numPages);
    }



    return <>
        {type === 'application/pdf' ?
            <Box aria-label='pdf-container' position='relative'
                sx={{ my: '2rem' }}
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
            >
                <Document file={file || urlObject} onLoadSuccess={onDocumentLoadSuccess} loading='Cargando documento' >
                    <Page width={400} pageNumber={pageNumber} loading='Cargando página' />
                </Document>
                <Paper
                    id="buttons-pdf"
                    elevation={3}
                    className={hover ? 'paper-hover' : ''}
                    sx={{
                        display: hover ? 'flex' : 'none',
                        transition: 'all 0.5s ease',

                    }}
                >
                    <Box component='button'
                        onClick={() => {
                            if (pageNumber > 1) {
                                setPageNumber(pageNumber - 1);
                            }
                        }}
                        sx={{
                            backgroundColor: 'white',
                            border: 0,
                            padding: '1rem',
                            borderRadius: '15px 0px 0px 15px',
                            '&:hover': {
                                backgroundColor: '#6f6f6f47',
                            }

                        }}>

                        {'<'}
                    </Box>
                    <Typography alignSelf='center' sx={{ inlineSize: 'max-content' }}>
                        {pageNumber} / {numPages}
                    </Typography>
                    <Box component='button'
                        onClick={() => {
                            if (numPages && pageNumber < numPages) {
                                setPageNumber(pageNumber + 1);
                            }
                        }}
                        sx={{
                            backgroundColor: 'white',
                            borderRadius: '0px 15px 15px 0px',
                            border: 0,
                            padding: '1rem',
                            '&:hover': {
                                backgroundColor: '#6f6f6f47',
                            }
                        }}>
                        {'>'}
                    </Box>

                </Paper>
            </Box >
            : <>


                <img src={urlObject || ''}
                    alt="factura"
                    style={{ width: "20rem", height: "100%" }}
                    onError={(e) => {
                        developerLog('error', e)
                        e.currentTarget.src = emptyFolder;
                    }}

                />

            </>}
    </>


}


const ModalFactura = ({
    carpeta,
    open,
    onCancel,
    onSubmit
}: ModalCarpetaProps) => {
    const [subirFacturaMutation] = useSubirFacturaACarpetaMutation();
    const [borrarFacturaMutation] = useBorrarFacturaMutation();
    const [loading, setLoading] = useState(false)

    const darkMode = useAppSelector((state: any) => state.theme.darkTheme);

    const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down("sm"));
    const boxWidth = isMobile ? "100%" : "50rem";

    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [selectFecha, setSelectFecha] = useState<Date | any>(dayjs().toDate().toISOString());

    if (!carpeta) {
        return null;
    }


    const handleUploadFile = async () => {
        if (selectedFile) {
            setLoading(true)
            const formData = new FormData()
            formData.append('factura', selectedFile);
            const date = dayjs(selectFecha).format("YYYY-MM-DD HH:mm:ss")
            
            try {

                const response = await subirFacturaMutation({
                    carpeta: carpeta.idCarrito,
                    factura: formData,
                    fecha: date
                })
                const { facturaAdjunta, ...rest } = carpeta
                //@ts-ignore
                let miCarpeta = { ...rest, facturaAdjunta: response?.data.data }
                MyToastShow({ message: 'Archivo subido con éxito', type: 'success' })


                onSubmit(miCarpeta);

            } catch (error: any) {
                MyToastShow({ message: 'Error al subir el archivo', type: 'error' })
                developerLog(error)
            }
            setLoading(false)
        }

    }

    const handleBorrarFactura = async () => {
        setLoading(true)
        try {
            await borrarFacturaMutation({ carpeta: carpeta.idCarrito })
            const { facturaAdjunta, ...rest } = carpeta
            //@ts-ignore
            let miCarpeta = { ...rest, facturaAdjunta: null } as ICarrito
            MyToastShow({ message: 'Factura borrada con éxito', type: 'success' })
            onSubmit(miCarpeta)
            onCancel()
        } catch (error: any) {
            MyToastShow({ message: 'Error al borrar la factura', type: 'error' })
            developerLog(error)
        }
        setLoading(false)
        setSelectedFile(null)

    }


    return (
        <Modal
            open={open}
            onClose={onCancel}
            aria-labelledby={`liquidar-informes`}
            sx={{
                width: "100%",
            }}
        >
            <Box
                sx={(theme) => ({
                    ...style,
                    width: boxWidth,
                    overflow: "auto",
                    maxHeight: "100%",
                    bgcolor: darkMode ? "#232323" : "#fff",
                })}
                aria-label={`liquidar-container-informes`}
            >




                <Box sx={{ display: "flex", justifyContent: "flex-end", flexDirection: 'column', mt: 0 }}>
                    <Typography variant='h3' textAlign='center' sx={{ borderBottom: !loading ? 'solid' : 'none' }}>Factura</Typography>
                    {loading && <LinearProgress />}

                    <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                        Carpeta número: {carpeta.idCarrito}
                    </Typography>

                    <Box display='flex'>
                        <Box sx={{ alignSelf: 'center', textAlign: 'center' }}>
                            <RenderPreviewFactura
                                file={selectedFile}
                                link={carpeta.facturaAdjunta}

                            />
                            <Button
                                component="label"
                                role={undefined}
                                variant="contained"
                                tabIndex={-1}
                            >
                                Seleccionar archivo
                                <VisuallyHiddenInput
                                    type="file"
                                    onChange={(e) => {
                                        if (e.target.files) {
                                            setSelectedFile(e.target.files[0]);
                                        }
                                    }}
                                    max={1}
                                />
                            </Button>
                        </Box>


                        <Box sx={{ width: '30rem', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                            <Box aria-label="information">
                                <Typography variant='h5'>Información de la factura</Typography>
                                <Typography variant='body1'>Estado: {carpeta.facturaAdjunta ?
                                    <Chip label="Facturado" color="success" size="small" />
                                    :
                                    <Chip label="No Facturado" color="error" size="small" />}
                                </Typography>
                                <Typography variant='body1' mb={2}>Envio programado</Typography>
                                <EnvioProgramado onChange={setSelectFecha} value={selectFecha} />
                            </Box>

                            <Box aria-label='action-buttons' sx={{ display: 'flex', justifyContent: 'space-between' }}>

                                <Box aria-label='with-selected-file-buttons' sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    rowGap: '1rem',

                                }}>

                                    <Button
                                        variant="contained"
                                        color="success"
                                        sx={{ ml: 1 }}
                                        disabled={!selectedFile}
                                        onClick={() => handleUploadFile()}
                                    >

                                        {carpeta.facturaAdjunta ? 'Actualizar factura' : 'Subir factura'}
                                    </Button>

                                    {carpeta.facturaAdjunta &&
                                        <Button
                                            variant="contained"
                                            color='warning'
                                            sx={{ ml: 1 }}
                                            onClick={() => handleBorrarFactura()}
                                        >

                                            Borrar factura
                                        </Button>}
                                </Box>
                                <Button
                                    variant="contained"
                                    color="error"
                                    sx={{ ml: 1, float: 'inline-end', height: '3rem' }}
                                    onClick={() => onCancel()}
                                >

                                    Cerrar
                                </Button>
                            </Box>





                        </Box>
                    </Box>


                </Box>
            </Box>
        </Modal >
    );
};

export default ModalFactura;
